import { Component, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { Poi, User } from 'shared';
import DataSource from 'devextreme/data/data_source';
import { PoiService } from '../../stores/poi.service';
import { PoiCategoryService } from '../../stores/poi-category.service';
import { UserDomainService } from '../../user-domains/user-domain.service';
import { MapService } from '../../services/map.service';
import ArrayStore from 'devextreme/data/array_store';
import { DxoFormComponent } from 'devextreme-angular/ui/nested';
import { DxFormComponent } from 'devextreme-angular';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-map-poi-popup',
  templateUrl: './map-poi-popup.component.html',
  styleUrls: ['./map-poi-popup.component.scss']
})
export class MapPoiPopupComponent implements OnInit {

  @Input()
  gridDs: DataSource;

  @Input()
  poi: Poi;
  catDsLookup: DataSource;

  @Input()
  startDrawing: (poi: Poi) => void;

  @ViewChild(DxFormComponent)
  form: DxFormComponent;

  selectedIndex = 0;

  buttonOptions: any = {
    text: 'Sauvegarder',
    type: 'default',
    stylingMode: 'text',
    useSubmitBehavior: true
  };
  private categoriesFetched: boolean;
  editSelectCategoryDisabled: boolean;

  changes = {};
  tabs: any[];

  constructor(
    private poiService: PoiService,
    private poiCategoryService: PoiCategoryService,
    private userDomainsService: UserDomainService,
    private mapService: MapService,
    private renderer: Renderer2,
    // public user: User
  ) {
    this.fetchCategories();
  }

  private async fetchCategories() {
    const remoteDs = this.poiCategoryService.newDataSource({
      paginate: false,
    });

    // Data source
    this.catDsLookup = new DataSource({
      paginate: false,
      store: new ArrayStore({
        key: 'id',
        data: await remoteDs.load(),
      }),
    });

    this.categoriesFetched = true;
  }

  ngOnInit() {
    this.tabs = [
      { text: 'Inforamtion' },
      { text: 'Editer' },
      { text: this.poi.type === 'POLYGON' ? 'Déssiner' : 'Déplacer' },
      { text: 'Proximité' },
    ];
  }

  selectTab(e: any) {
    if (this.selectedIndex === 2) {
      this.startDrawing(this.poi);
      // @ts-ignore
      this.poi.layer.editing.enable();
      this.poi.layer.closePopup();
      let tt = this.poi.layer.bindTooltip('Cliquer sur "Entrer" pour Sauvegarder/Annuler.', {
        direction: this.poi.type === 'POLYGON' ? 'center' : 'top',
        permanent: true,
        offset: [0, -40],
        opacity: 0.8,
      });
      const hitEnter = this.renderer.listen('document', 'keyup', ev => {
        if (ev.keyCode !== 13) {
          return;
        }
        tt.remove();
        tt = this.poi.layer.bindTooltip('En cours...', {
          direction: this.poi.type === 'POLYGON' ? 'center' : 'top',
          offset: [0, -40],
          permanent: true,
          sticky: true,
          opacity: 1,
        });
        const store = this.gridDs.store();
        store.update(this.poi.id, { geometry: this.poi.geometry }).then(() => {
          tt.remove();
          this.gridDs.reload();
        });
        hitEnter();
      });
      this.mapService.mapReady$.pipe(first()).subscribe((map) => {
        map.fitBounds(this.poi.getBounds());
      });
    }
  }

  onFormSubmit(e: Event) {
    e.preventDefault();
    if (Object.keys(this.changes).length === 0) {
      this.poi.layer.closePopup();
      return;
    }
    const store = this.gridDs.store();
    store.update(this.poi.id, this.changes).then(() => {
      this.poi.layer.closePopup();
      this.gridDs.reload();
    });
    /*this.poiService.update(this.poi.id, this.changes as Poi).subscribe((poi: Poi) => {
      this.poi = Object.assign(this.poi, this.changes);
      this.poi.domain_name = p
    });*/
  }

  async domainChange(e: number) {
    this.poi.domain_id = e;
    this.changes['domain_id'] = e;

    this.editSelectCategoryDisabled = true;
    this.catDsLookup.filter(['domain_id', '=', e]);
    this.catDsLookup.reload().then(() => {
      this.editSelectCategoryDisabled = false;
    });
  }

  addFieldChange(e: any) {
    this.changes[e.dataField] = e.value;
  }
}
